import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export default function ConfigQrPanel({
  checkinSlug,
  checkinUrl,
  qrDataUrl,
  qrLoading = false,
  hasQrCode = false,
  onCopyCheckinUrl,
}) {
  return (
    <Paper variant="outlined" sx={{ p: 3, mb: 4, borderRadius: 3 }}>
      <Box display="flex" alignItems="center" gap={1} mb={1}>
        <QrCode2Icon color="primary" />
        <Box>
          <Typography variant="subtitle1" fontWeight="bold">
            QR Code para check-in
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Este é o QR Code que o cliente escaneia na mesa ou no balcão.
          </Typography>
        </Box>
      </Box>
      {checkinSlug ? (
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={5} md={4} display="flex" justifyContent="center">
            <Box
              sx={{
                border: '1px dashed #e0e0e0',
                borderRadius: 2,
                p: 1,
                backgroundColor: '#fff',
              }}
            >
              {qrLoading ? (
                <Box display="flex" alignItems="center" justifyContent="center" width={220} height={220}>
                  <CircularProgress size={28} />
                </Box>
              ) : hasQrCode ? (
                <img
                  src={qrDataUrl}
                  alt="QR Code de check-in"
                  crossOrigin="anonymous"
                  className="clube-qr-image"
                />
              ) : (
                <Box display="flex" alignItems="center" justifyContent="center" width={220} height={220}>
                  <Typography variant="body2" color="text.secondary">
                    QR Code indisponível
                  </Typography>
                </Box>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} sm={7} md={8}>
            <Typography variant="body2" color="text.secondary" mb={1}>
              Este QR Code é público e deve ficar visível para os clientes.
            </Typography>
            <TextField
              label="Link público de check-in"
              fullWidth
              value={checkinUrl}
              placeholder="Gerando link..."
              InputProps={{ readOnly: true }}
            />
            <Box display="flex" gap={1} mt={2} flexWrap="wrap">
              <Button
                variant="outlined"
                startIcon={<ContentCopyIcon />}
                onClick={onCopyCheckinUrl}
                disabled={!checkinUrl}
              >
                Copiar link
              </Button>
              <Button
                variant="outlined"
                startIcon={<OpenInNewIcon />}
                onClick={() => window.open(checkinUrl, '_blank')}
                disabled={!checkinUrl}
              >
                Abrir link
              </Button>
            </Box>
            <Typography variant="caption" color="text.secondary" display="block" mt={1}>
              Copiar é indicado para uso digital. Abrir serve para teste rápido.
            </Typography>
          </Grid>
        </Grid>
      ) : (
        <Typography variant="body2" color="text.secondary">
          Slug de check-in não encontrado. Configure no cadastro do restaurante.
        </Typography>
      )}
    </Paper>
  );
}
